import './publicPath';
import { AccessibilityLink } from './accessibility-link';
import { OverrideStyles } from './blog/override-styles';
import { CartSessionHandler } from './cart/cart-session-handler';
import MediaLoader from './design-system/media-loader';
import ButtonLinks from './design-system/button-links';
import HandlersByClassName from './handlers-by-classname';
import { ABTestGroup } from './shared/ab_test';
import Navigation from './navigation';
import CartPopup from './cart-popup';
import VariantDataSelector from './selectors/variant-data';
import CustomerDataSelector from './selectors/customer-data';
import { DiscountCodeSnackbar } from './discount-code-snackbar';
import FormSubmitHandler from './forms/submit-handler';
import { GlobalSnackbar } from './global-snackbar';
import CurrentVariantStorage from './storage/variant-storage';
import NewCart from './components/cart/index.jsx';
import analytics from './analytics';
import GeoLocation from './geolocation';
import ScrollReveal from './scroll-reveal';
import { generateSessionID } from './utils/generate-session-id';

window.variantDataSelector = new VariantDataSelector();
window.customerDataSelector = new CustomerDataSelector();

document.addEventListener('DOMContentLoaded', () => {
  const bodyClassList = document.body.classList;

  analytics.pageLoaded({ classList: bodyClassList });
  window.currentVariantStorage = new CurrentVariantStorage();

  const sessionId = generateSessionID();
  sessionStorage.setItem('session_id', sessionId);

  (new AccessibilityLink()).initialize();
  (new GeoLocation()).saveCurrentLocation();
  (new ButtonLinks()).initializeEventListeners();
  (new CartPopup()).initializeEventListeners();
  (new GlobalSnackbar()).initialize();
  (new DiscountCodeSnackbar()).initialize();
  (new FormSubmitHandler()).initializeEventListeners();
  (new MediaLoader()).initialize();
  (new Navigation()).initializeEventListeners();
  (new NewCart()).initialize();
  (new HandlersByClassName()).initializeHandlers();
  (new OverrideStyles().initialize());
  (new ScrollReveal()).initialize();

  const CartHandler = new CartSessionHandler(['path']);
  CartHandler.init();

  ABTestGroup.set();
});
